var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"border-top border-secondary",attrs:{"fixed":"bottom","variant":"light"}},[_c('div',{staticClass:"ml-auto"},[_c('social-networks')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }